import React from 'react'
import Slider from 'react-slick'
import SliderSettings from '~/tools/slickSliderSettings'

class SeasonListTabularView extends React.Component {
	constructor(props){
		super(props)
		this.handleChange = this.handleChange.bind(this)
	}
	handleChange(e, selectedIndex){
		//Remove focus to prevent blue border box
		e.target.blur();
		
		const {scrollTo, deviceType} = this.props
		this.props.handleChange(e, selectedIndex)
		if(deviceType === 'mobile'){ window.scrollTo(0, scrollTo) }
	}
	render(){
		const primaryBackgroundColor = window.settings.brand && window.settings.brand.general.backgroundColor;
		const seasonNames = this.props.seasonNames
		const totalSeasons = this.props.seasonNames.length
		const {columns, currentSeason, deviceType} = this.props
		const sliderSettings = new SliderSettings(columns)
		var hasMultipleItems = seasonNames.length > columns[deviceType]
		var classNames = 'season-list-tabular-view ' + (hasMultipleItems ? 'hasMultipleItems ' : '') + deviceType
		return(
			<div 
				ref={elem => (this.seasonListEl = elem)}
				className={classNames}
				style={{
					top: 0,
					backgroundColor: (deviceType === 'mobile') ? primaryBackgroundColor : ''
				}}>
				<Slider
					dots={false}
					infinite={false}
					arrows={ hasMultipleItems }
					slidesToShow={ sliderSettings.slidesToShow }
					slidesToScroll={ 1 }
					responsive={ sliderSettings.responsiveBreakpoints } >
					{seasonNames.map((seasonName, key) => (
						<div tabIndex="-1" key={key} className={'season-title ' + ((totalSeasons - (key + 1) === currentSeason) ? 'current site-color' : '')}>
							<a 
								href=""
								key={totalSeasons - (key + 1)} 
								data-season={totalSeasons - (key + 1)}
								onClick={(e) => {e.preventDefault(); this.handleChange(e, totalSeasons - (key + 1))}}>
								{seasonName || `Season ${totalSeasons - key}`}
							</a>
						</div>
					))}
				</Slider>
			</div>
		)
	}
}

export default SeasonListTabularView;